import {Action} from '@ngrx/store';
import {
    StructureModel
} from '../models/structure-authz.model';

export const AUTHZ_STRUCTURES_LIST = '[AUTHZ] Authorized Structures list';
export const AUTHZ_STRUCTURES_LIST_SUCCESS = '[AUTHZ] Authorized Structures list Success';
export const AUTHZ_STRUCTURES_LIST_ERROR = '[AUTHZ] Authorized Structures list Error';
export const AUTHZ_SELECT_STRUCTURE = '[AUTHZ] Select on of the authorized Structure';

export const AUTHZ_INIT = '[AUTHZ] Initiate Authorization treatments';
export const AUTHZ_INIT_SUCCESS = '[AUTHZ] Initiate Authorization treatments Success';
export const AUTHZ_INIT_ERROR = '[AUTHZ] Initiate Authorization treatments Error';

export const AUTHZ_INIT_PROCESS = '[AUTHZ] Initiate Authorization processing';
export const AUTHZ_INIT_PROCESS_SUCCESS = '[AUTHZ] Initiate Authorization process Success';
export const AUTHZ_INIT_PROCESS_ERROR = '[AUTHZ] Initiate Authorization process Error';

export const AUTHZ_EXTENSION_BEFORE_INIT = '[AUTHZ] Extension - Before Initiate Authorization';
export const AUTHZ_EXTENSION_BEFORE_INIT_RESPONSE = '[AUTHZ] Extension - Before Initiate Authorization Response';

export const AUTHZ_DISPLAY_ERROR = '[AUTHZ - Error] Display';

/** Action to load the authorized structures list for user */
export class AuthZStructuresList implements Action {
    readonly type = AUTHZ_STRUCTURES_LIST;
}

/** Action to load the authorized structures list for user successed */
export class AuthZStructuresListSuccess implements Action {
    readonly type = AUTHZ_STRUCTURES_LIST_SUCCESS;

    constructor(public autorizedStructuresList: Array<StructureModel>) {
    }
}

/** Action to load the authorized structures list for user failed */
export class AuthZStructuresListError implements Action {
    readonly type = AUTHZ_STRUCTURES_LIST_ERROR;

    constructor(public payload?: any) {
    }
}

/** Action to select one of the authorized structures list for user */
export class AuthZSelectStructure implements Action {
    readonly type = AUTHZ_SELECT_STRUCTURE;

    constructor(public structure: StructureModel) {
    }
}

export class AuthZExtensionBeforeInit implements Action {
  readonly type = AUTHZ_EXTENSION_BEFORE_INIT;

  constructor(public structure: StructureModel) {
  }
}

export class AuthZExtensionBeforeInitResponse implements Action {
  readonly type = AUTHZ_EXTENSION_BEFORE_INIT_RESPONSE;
}

/** Action to initiate processing for authorizations after authentification */
export class AuthZInit implements Action {
    readonly type = AUTHZ_INIT;

    constructor(public autorizedStructure: StructureModel) {
    }
}

export class AuthZInitProcess implements Action {
  readonly type = AUTHZ_INIT_PROCESS;

  constructor(public autorizedStructure: StructureModel, public modules: string[], public traitements: string[], public perimetres: string[]) {
  }
}

export class AuthZInitProcessSuccess implements Action {
  readonly type = AUTHZ_INIT_PROCESS_SUCCESS;

  constructor(
    public autorizedModules: Array<string>,
    public requestingModule: string,
    public hasAccessToRequestingModule: boolean,
    public traitementsListForRequestingModule: string[],
    public perimetresListForUser: string[]
  ) {
  }
}
export class AuthZInitProcessError implements Action {
  readonly type = AUTHZ_INIT_PROCESS_ERROR;

  constructor(public payload?: any) {
  }
}

/** Action initiate processing for authorizations after authentification successed */
export class AuthZInitSuccess implements Action {
    readonly type = AUTHZ_INIT_SUCCESS;
}

/** Action initiate processing for authorizations after authentification failed */
export class AuthZInitError implements Action {
    readonly type = AUTHZ_INIT_ERROR;

    constructor(public payload?: any) {
    }
}

/** Action to display error */
export class AuthZDisplayError implements Action {
    readonly type = AUTHZ_DISPLAY_ERROR;

    constructor(public payload?: any) {
    }
}


export type AuthZAction =
    | AuthZInit
    | AuthZInitSuccess
    | AuthZInitError

    | AuthZInitProcess
    | AuthZInitProcessSuccess
    | AuthZInitProcessError

    | AuthZExtensionBeforeInit
    | AuthZExtensionBeforeInitResponse

    | AuthZStructuresList
    | AuthZStructuresListSuccess
    | AuthZStructuresListError
    | AuthZSelectStructure

    | AuthZDisplayError;

